// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductCarbonFootprint_wrapper__HKGF+"};